import { Component, input, output } from '@angular/core';
import { ToggleComponent } from '../../../toggle/toggle.component';

@Component({
  selector: 'pozi-route-speed-control',
  imports: [ToggleComponent],
  templateUrl: './route-speed-control.component.html',
  styleUrl: './route-speed-control.component.scss',
})
export class RouteSpeedControlComponent {
  isToggled = input<boolean>(false);
  icon = input<string>('speed.svg');
  toggleChange = output<boolean>();

  readonly minRelativeSpeedPercentage = 50;
  readonly maxRelativeSpeedPercentage = 150;
}
